import { useState } from "react";
import AdminToast from "../../../core/admin/adminToast";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../../firebase";
import AdminButton from "../../../core/admin/adminButton";
import AdminCard from "../../../core/admin/adminCard";
import AdminTable from "../../../core/admin/adminTable";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { AdminCount } from "../../../core/admin/adminBadge";
import { formatPhoneNumber } from "../../../../utils/functions";

interface IUser {
    id: string;
    name: string;
    phoneNumber: string;
    email: string;
    roles: string[];
}

export default function AdvertisersList() {

    const [loading, setLoading] = useState(false);
    const [badToast, setBadToast] = useState(false);
    const [advertisers, setAdvertisers] = useState<IUser[]>([]);
    const [message, setMessage] = useState("");

    const searchAdvertisers = async () => {
        try {
            let docs: any[] = []
            setLoading(true);
            const col = collection(db, "users");
            const q = query(col, where("roles", "array-contains", "advertiser"));
            const documents = await getDocs(q);
            documents.docs.map(doc => docs.push({ id: doc.id, ...doc.data() }));
            setAdvertisers(docs);
            setMessage("Busca realizada!");
            setLoading(false);
        } catch (error) {
            console.log(error)
            setMessage("");
            setLoading(false);
            setBadToast(true);
        }
    }

    return (
        <AdminCard
            title={<>Usuários anunciantes {message ? <AdminCount count={advertisers.length} /> : null}</>}
            actions={<AdminButton variant="secondary" loading={loading} onClick={searchAdvertisers}>{message ? "Atualizar lista" : "Listar"}</AdminButton>}
            bodyClassName="p-3 md:p-4"
        >
            {
                loading ?
                    <AdminLoading />
                    : advertisers.length ?
                        <AdminTable
                            rows={advertisers}
                            rowKey={(adv, idx) => adv.id || idx}
                            columns={[
                                { header: "Nome", mobile: "title", render: adv => <span className="font-semibold">{adv.name || "—"}</span> },
                                { header: "E-mail", render: adv => <span className="break-all">{adv.email}</span> },
                                { header: "Telefone", className: "whitespace-nowrap", render: adv => adv.phoneNumber ? formatPhoneNumber(adv.phoneNumber) : "—" },
                                { header: "ID", render: adv => <span className="font-mono text-xs text-gray-500 break-all">{adv.id}</span> },
                            ]}
                        />
                        :
                        <AdminEmptyState title={message ? "Nenhum anunciante encontrado" : "Nenhum usuário listado"} description={message ? undefined : "Clique em “Listar” para carregar os anunciantes."} />
            }
            <AdminToast message="Erro na busca!" toast={badToast} setToast={setBadToast} tone="danger" />
        </AdminCard>
    )
}
